import { Component, Input, OnChanges } from "@angular/core";

/**
 * Component that display a number in a badge, like common notification badges.
 * @param count Number to display inside the badge
 * @param bright Indicates if the badge shouldl be bright (true - default), or drab (false)
 * @param subcounts[] Optional values to use to construct the tooltip string
 * @param tooltip Tootip associated with the badge. May contain wildcards :
 *  %: Replaced with the value of _count_
 *  (s): Replaced with 's' if count != 1, else ''
 *  $*: With * having a value between 0 and _subcounts.length_, replaced with the value of _subcounts[*]_
 *  (s*): Replaced with 's' if _subcounts[*]_ != 1, else ''
 */
@Component({
  selector: "app-notification-badge",
  templateUrl: "./notification-badge.component.html",
  styleUrls: ["./notification-badge.component.scss"],
})
export class NotificationBadgeComponent implements OnChanges {
  @Input() count: number;
  @Input() bright: boolean = false;
  @Input() tooltip: string;
  @Input() subcounts: number[] = [];

  tooltipText = "";

  ngOnChanges(): void {
    let text = this.tooltip;
    text = text
      .replace("%", this.count > 0 ? this.count + "" : "No")
      .replace("(s)", this.count != 1 ? "s" : "");
    for (let i = 0; i < this.subcounts.length; i++) {
      text = text
        .replace("$" + i, this.subcounts[i] > 0 ? this.subcounts[i] + "" : "no")
        .replace("(s" + i + ")", this.subcounts[i] != 1 ? "s" : "");
    }
    this.tooltipText = text;
  }
}
